import { useState } from "react";
import styled from "styled-components";
import MobileUpdatePasswordModal from "../../../components/mobile/MobilePasswordModal";
import MobileSubTitle from "../../../components/mobile/MobileSubTitle";

const SubTitleContainer = styled.div`
  padding: 60px 16px 0;
  display: flex;
  align-items: flex-end;
  gap: 10px;
  color: #2aa4d5;
  font-weight: 700;

  h3 {
    font-size: 18px;
  }

  span {
    font-size: 20px;
  }

  ::before {
    position: absolute;
    left: 0px;
    bottom: calc(100% + 15px);
    content: "";
    display: block;
    width: 25px;
    height: 3px;
    background-color: #186fb2;
  }
`;

const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 16px;
  margin-bottom: 100px;
`;

const Button = styled.button`
  display: block;
  margin: 0 auto;
  margin-top: 58px;
  width: 100%;
  max-width: 80px;
  padding: 0 20px;
  height: 40px;
  border-radius: 12px;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  background-color: #00a7db;
  &:hover {
    background-color: #0087b3;
  }
`;

export const PasswordSetting = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <SubTitleContainer>
        <MobileSubTitle title="비밀번호 변경" />
      </SubTitleContainer>
      <Container>
        <Button onClick={() => setIsOpen(true)}>변경</Button>
        {isOpen && <MobileUpdatePasswordModal onClose={() => setIsOpen(false)} />}
      </Container>
    </>
  );
};

